<div class="theme-static">
  <section class="header position-fixed w-100">
    <app-common-header></app-common-header>
  </section>

  <!-- End Header Part -->

  <!-- Start Page Header Title Part -->
  <section class="page-header-title">
    <div class="page-title-overlay"></div>
    <img src="{{ pageTitleImg }}" alt="" class="w-100 page-title-image" />
    <div class="page-header-title-caption">
      <h1>{{ pageHead }}</h1>
    </div>
  </section>
  <!-- End Page Ttile  -->

  <!-- Main Content -->
  <main class="page-content py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="page-content-info">
            <p class='text-dark'> <strong>This travel alert is no longer active and will not impact coverage for a new policy purchase.</strong> </p>
            <p>This information is in relation to the ‘Do Not Travel’ Warnings currently in effect for China and Iran.</p>
            <p>Due to the risk and spread of Coronavirus, the Australian government updated the travel warnings for China on Saturday 1 February 2020, and Iran on Saturday 29 February 2020, to ‘Do Not Travel’ as advised on 
              <a href="https://smartraveller.gov.au" target="_blank">smartraveller.gov.au.</a>
            </p>
            <p>All travel insurance policies purchased after the above dates exclude cover to any country with the advice of Do Not Travel and we cannot offer cover for these destinations. This means that if you purchase a policy to China or Iran whilst the Do Not Travel restrictions are in place, there is no cover for any claims related to Coronavirus.</p>
          </div>
        </div>
      </div>
    </div>
  </main>
  <!-- Footer Area -->
  <app-footer></app-footer>
</div>
